import React, { Component } from 'react';
import 'index.css';
import './Controls.css';
import './PauseBtn.scss';

class PauseBtn extends Component {
    constructor(props) {
        super(props);
        this.handlePause = this.props.onPause ? this.props.onPause.bind(this) : null;
    }
    render() {
        let btnClass="controls-pause-btn controls-btn";
        let clickHandler=null;
        if (this.props.playing) {
            btnClass+=" playing";
            clickHandler=this.handlePause;
        }
        return (
            <span className={btnClass} onClick={clickHandler}>
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="15" viewBox="0 0 11 15">
              <g id="Groupe_12" data-name="Groupe 12" transform="translate(0.263 0.153)">
                <rect id="Rectangle_82" data-name="Rectangle 82" width="4" height="15" transform="translate(-0.263 -0.153)"/>
                <rect id="Rectangle_83" data-name="Rectangle 83" width="4" height="15" transform="translate(6.737 -0.153)"/>
              </g>
            </svg>
            </span>
        );
    }
}
export default PauseBtn;
